import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import { DetailsProps } from './types';
import CommissionDetails from './Commission';
import PollDetails from './Poll';
import StatusDetails from './Status';
import JournalDetails from './Journal';
import LiteratureDetails from './Literature';
import TierDetails from './Tier';
import DefaultDetails from './Default';

export const Details: React.FC<DetailsProps> = props => {
  const deviationType = getDeviationType(props.deviation as PapiDeviation);
  switch (deviationType) {
    case DeviationTypes.COMMISSION:
      return <CommissionDetails {...props} />;
    case DeviationTypes.POLL:
      return <PollDetails {...props} />;
    case DeviationTypes.STATUS:
      return <StatusDetails {...props} />;
    case DeviationTypes.JOURNAL:
      return <JournalDetails {...props} />;
    case DeviationTypes.LITERATURE:
      return <LiteratureDetails {...props} />;
    case DeviationTypes.TIER:
      return <TierDetails {...props} />;
    default:
      return <DefaultDetails {...props} />;
  }
};
Details.displayName = 'Details';

export default Details;
